import { createFeatureSelector, createSelector } from '@ngrx/store';

import { AppState } from '../shared/models/shared.models';

export const selectAppState = createFeatureSelector<AppState>('app');

export const selectUserNavigationItems = createSelector(
  selectAppState,
  (state) => state?.userNavigationItems,
);

export const selectCustomerBrsNumbers = createSelector(
  selectAppState,
  (state) => state?.customerBrsNumbers,
);

export const selectCustomerKvkNumbers = createSelector(
  selectAppState,
  (state) => state?.customerKvkNumbers,
);
